<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import PageHeader from "@/components/page-header";
import axios from "axios";
import DataTable from "@/components/DataTable.vue";

/**
 * Unreconciled Items component
 */
export default {
  page: {
    title: "Unreconciled Items Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },
  data() {
    return {
      title: "Unreconciled Items Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Unreconciled Items Report",
          active: true,
        },
      ],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsUnreconciledItemsServerPaginated: true,
      filter: null,
      filterOn: [],
      sortDesc: false,
      currentdate: moment(new Date()).format("DD-MM-YYYY"),
      filterProducts:{
        product: '',
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 50,
      },
      is_exporting: false,
     
      unreconciledItemsColumns: [
        {
          key: "sn",
          label: "S/N",
          formatter: (_, __, idx) => this.UnreconciledItemsPagination.from + idx,
        },
        {
          key: "product_name",
          label: "PRODUCT NAME",
        },
        {
          key: "product_code",
          label: "PRODUCT CODE",
        },
        {
          key: "quantity",
          label: "QUANTITY",
        },
        {
          key: "selling_price",
          label: "SELLING PRICE",
        },
      ],


      json_fields: {
        PRODUCT_NAME: "product_name",
        PRODUCT_CODE: "product_code",
        QUANTITY: "quantity",
        SELLING_PRICE: "selling_price"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      exportUnreconciledItems() {
        this.is_exporting = true;
        axios
            .post("unreconciled-items/export", this.filterProducts, {
              responseType: "arraybuffer",
            })
            .then((response) => {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("download", "unreconciled-items.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
              this.is_exporting = false;
            })
            .catch(() => {
              this.is_exporting = false;
            });
      },
    };
  },
  computed: {
    ...mapGetters("stock", [
      "UnreconciledItemsPagination",
      "FilterStatus",
      "UnreconciledItems",
      "UnreconciledItemsSummary",
      "UnreconciledItems",
      "UnreconciledItemsPaginated",

    ]),

   rows() {
      return this.IsUnreconciledItemsServerPaginated
        ? this.UnreconciledItemsPagination.total
        : this.UnreconciledItems
        ? this.UnreconciledItems.length
        : 0;
    },

   perPage: {
      get() {
        if (this.IsUnreconciledItemsServerPaginated) {
          return (
            (this.UnreconciledItemsPagination && this.UnreconciledItemsPagination.per_page) ||
            this.filterProducts.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsUnreconciledItemsServerPaginated) {
          this.filterProducts.per_page = value;
          this.filterProducts.page = 1;
          this.FetchReportData(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.UnreconciledItemsPaginated && this.UnreconciledItemsPagination
          ? this.UnreconciledItemsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.UnreconciledItemsPaginated) {
          this.filterProducts.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
        return (
          this.UnreconciledItemsSummary || {
            totalAmount: 0,
            totalPaid: 0,
            totalDiscount: 0,
            totalBalance: 0,
          }
        );
      },

  },
  methods: {
    ...mapActions({
      FetchReportData: "stock/fetchUnReconciledItemsData",
    }),

    onFiltered() {
      if (!this.IsUnreconciledItemsServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    FilterReport(){
      this.filterProducts.page = 1;
      this.FetchReportData(this.filterProducts);
    },

    handlePageChange(newPage) {
      if (this.IsUnreconciledItemsServerPaginated) {
        this.filterProducts.page = newPage;
        this.FetchReportData(this.filterProducts);
      }
    },

    calculateIndex(index) {
      if (this.IsUnreconciledItemsServerPaginated) {
        return (this.UnreconciledItemsPagination.from - 1) + index;
      } else {
        return (this.clientPerPage * (this.clientCurrentPage - 1)) + index;
      }
    }
  },
  created() {
    this.FetchReportData(this.filterProducts);
  },
};
</script>

<style scoped>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 mb-2">
                <b-button variant="info" class="me-2" @click="exportUnreconciledItems()" :disabled="is_exporting">
                  <span v-if="!is_exporting">
                    Export Excel <i class="fa fa-download"></i>
                  </span>
                  <span v-else>
                    <b-spinner small></b-spinner> Exporting...
                  </span>
                </b-button>
              </div>
              <div class="col text-end mt-4">
                <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-arrow-left"></i> Back </b-button>
              </div>
            </div>

            <div class="row mt-4 mb-4">
              <div class="col-sm-12 col-md-3 d-flex align-items-end">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <div class="col-sm-6 col-md-2 d-flex align-items-end">
                <div class="form-group mb-0 w-100">
                  <label class="mb-0">From</label>
                  <input
                      type="date"
                      v-model="filterProducts.datefrom"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-sm-6 col-md-3 d-flex align-items-end">
                <div class="form-group mb-0 w-100">
                  <label class="mb-0">To</label>
                  <input
                      type="date"
                      v-model="filterProducts.dateto"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-sm-12 col-md-4 d-flex align-items-end">
                <div class="w-100">
                  <label class="mb-0">Search Product</label>
                  <div class="input-group">
                    <input
                        v-model="filterProducts.product"
                        type="text"
                        class="form-control"
                        placeholder="Enter product name or code"
                        @keyup.enter="FilterReport()"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="button" @click="FilterReport()">
                        <b-spinner
                            v-if="FilterStatus"
                            variant="light"
                            small
                            label="Searching"
                        ></b-spinner>
                        <span>Search</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
              :columns="unreconciledItemsColumns"
              :rows="UnreconciledItems ? UnreconciledItems : []"
              :total-rows="rows"
              :pagination="UnreconciledItemsPagination"
              :server-pagination="IsUnreconciledItemsServerPaginated"
              :loading="FilterStatus"
              row-class="reconciliation-bordered"
            >
              <!-- S/N -->
              <template #cell(sn)="{ index }">
                {{ UnreconciledItemsPagination.from + index }}
              </template>

              <!-- PRODUCT NAME -->
              <template #cell(product_name)="{ value }">
                {{ value }}
              </template>

              <!-- PRODUCT CODE -->
              <template #cell(product_code)="{ value }">
                {{ value }}
              </template>

              <!-- QUANTITY -->
              <template #cell(quantity)="{ row }">
                {{ row.quantity ? row.quantity.toLocaleString() : 0 }}
              </template>

              <!-- SELLING PRICE -->
              <template #cell(selling_price)="{ row }">
                {{ row.selling_price ? row.selling_price.toLocaleString() : 0 }}
              </template>
            </DataTable>

            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="unreconciled-items-table"
                        class="btn-warning"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
